import type { IconData } from '@stacksjs/iconify-core'

export const visualBlindRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24.002 9.75c-3.395 0-6.583.83-9.363 2.29l3.092 3.092c4.305-2.975 10.25-2.546 14.082 1.285c3.831 3.831 4.26 9.777 1.285 14.081l3.409 3.41c3.07-2.452 5.355-5.783 6.446-9.581a1.2 1.2 0 0 0 0-.668C40.65 15.67 33.065 9.75 24.002 9.75m-14.29 5.952q.726-.742 1.529-1.404l21.818 21.818q-.991.5-2.045.888zm-2.5 3.157l19.244 19.244a20.5 20.5 0 0 1-2.79.144l-17.501-17.5q.47-.976 1.048-1.888m-1.694 6.898l11.115 11.115c-5.151-2.014-9.209-6.075-11.115-11.115m-4.316-3.188C3.998 12.834 13.173 5.75 24.002 5.75c10.822 0 19.993 7.076 22.795 16.802c.27.94.27 1.938 0 2.879c-2.795 9.735-11.97 16.819-22.799 16.819c-10.822 0-19.993-7.076-22.795-16.802a5.2 5.2 0 0 1 0-2.879\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default visualBlindRemix
